import { render, staticRenderFns } from "./Copayment.vue?vue&type=template&id=29919f8e&scoped=true"
import script from "./Copayment.js?vue&type=script&lang=js&external"
export * from "./Copayment.js?vue&type=script&lang=js&external"
import style0 from "./Copayment.vue?vue&type=style&index=0&id=29919f8e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29919f8e",
  null
  
)

export default component.exports